import * as Yup from "yup";

export const CNIC_DIGITS_REGEX = /^\d{13}$/;
export const CNIC_REGEX = /^\d{5}-\d{7}-\d{1}$/;
export const CNIC_FORMAT = "XXXXX-XXXXXXX-X";
export const CNIC_MESSAGE = `Please enter a valid CNIC in format ${CNIC_FORMAT}`;

export const getCnicDigits = (value) => String(value || "").replace(/\D/g, "").slice(0, 13);

export const formatCnicValue = (value) => {
  const digits = getCnicDigits(value);

  if (!digits) return "";
  if (digits.length <= 5) return digits;
  if (digits.length <= 12) return `${digits.slice(0, 5)}-${digits.slice(5)}`;

  return `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12, 13)}`;
};

export const isValidCnic = (value) =>
  CNIC_REGEX.test(String(value || "").trim()) || CNIC_DIGITS_REGEX.test(getCnicDigits(value));

export const buildCnicSchema = (requiredMessage = "CNIC is required") =>
  Yup.string()
    .trim()
    .test("cnic-format", CNIC_MESSAGE, (value) => {
      if (!value) return true;
      return isValidCnic(value);
    })
    .required(requiredMessage);
